import { render } from "./NewTrainerForm.vue?vue&type=template&id=4df2e538&scoped=true"
import script from "./NewTrainerForm.vue?vue&type=script&lang=js"
export * from "./NewTrainerForm.vue?vue&type=script&lang=js"

import "./NewTrainerForm.vue?vue&type=style&index=0&id=4df2e538&scoped=true&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df2e538"]])

export default __exports__